'use client';

import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export default function CopyEmailButton({ email }: { email: string }) {
    const [copied, setCopied] = useState(false);

    async function handleCopy() {
        try {
            await navigator.clipboard.writeText(email);
        } catch {
            // Fallback for older browsers / non-secure contexts
            const textarea = document.createElement('textarea');
            textarea.value = email;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
            } catch {
                // ignore
            }
            document.body.removeChild(textarea);
        }
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }

    return (
        <button
            type="button"
            onClick={handleCopy}
            title="ইমেইল কপি করুন"
            className="group flex items-center gap-2 text-sm font-bold text-slate-300 hover:text-red-500 transition-colors cursor-pointer"
        >
            <span className="break-all">{email}</span>
            {copied ? (
                <Check className="w-4 h-4 shrink-0 text-green-500" />
            ) : (
                <Copy className="w-4 h-4 shrink-0 opacity-60 group-hover:opacity-100" />
            )}
            <span className="sr-only">{copied ? 'কপি হয়েছে' : 'ইমেইল কপি করুন'}</span>
        </button>
    );
}
